import { useContext } from 'react';
import WordlistContext, { WordlistTab } from '../_contexts/WordlistContext';

export default function useWordlistWords() {
  const { favoriteIds: favorites, currentTab, wordlist, searchResults } = useContext(WordlistContext);

  if (!wordlist) return;

  if (currentTab === WordlistTab.LIST) return wordlist.words;
  if (currentTab === WordlistTab.FAVORITES) return wordlist.words.filter(word => favorites.includes(word.id));
  if (currentTab === WordlistTab.SEARCH) return searchResults;
}
